"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegacyBaseDriverFromWrapper = exports.getBaseReactDriver = exports.isBaseDriver = exports.simulateMouseOut = exports.simulateMouseOver = exports.pressKey = exports.enterValue = exports.simulateBlur = exports.simulateClick = exports.createBaseDriverList = void 0;
var namespace_classes_1 = require("./namespace-classes");
var test_utils_1 = require("react-dom/test-utils");
var answers_lib_1 = require("@wix/answers-lib");
exports.createBaseDriverList = function (drivers) {
    var list = {
        count: function () { return drivers.length; },
        map: function (fn) { return drivers.map(fn); },
        filter: function (fn) { return exports.createBaseDriverList(drivers.filter(fn)); },
        get: function (idx) { return drivers[idx]; },
        toArray: function () { return drivers; },
        getText: function () { return drivers.map(function (d) { return d.getText(); }); },
        getAttribute: function (name) { return drivers.map(function (d) { return d.getAttribute(name); }); },
        clickOn: function (idx) { return list.get(idx).click(); }
    };
    return list;
};
exports.simulateClick = function (elem) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('click', true, false);
    // tslint:disable:max-line-length
    // setting button 0 is now needed in React 16+ as it's not set by react anymore
    // 15 - https://github.com/facebook/react/blob/v15.6.1/src/renderers/dom/client/syntheticEvents/SyntheticMouseEvent.js#L45
    // 16 - https://github.com/facebook/react/blob/master/packages/react-dom/src/events/SyntheticMouseEvent.js#L33
    event.button = 0;
    elem.dispatchEvent(event);
};
exports.simulateBlur = function (elem) {
    var event = document.createEvent('HTMLEvents');
    event.initEvent('blur', true, false);
    elem.dispatchEvent(event);
};
exports.enterValue = function (elem, value) {
    elem.value = value;
    test_utils_1.Simulate.change(elem);
};
exports.pressKey = function (elem, keyCode) {
    var event = new Event('keydown', { bubbles: true });
    event.keyCode = keyCode;
    elem.dispatchEvent(event);
};
exports.simulateMouseOver = function (elem) {
    test_utils_1.Simulate.mouseOver(elem);
};
exports.simulateMouseOut = function (elem) {
    test_utils_1.Simulate.mouseOut(elem);
};
exports.isBaseDriver = function (elemOrDriver) {
    return !!elemOrDriver.findAll;
};
exports.getBaseReactDriver = function (elemOrDriver) {
    var elem = exports.isBaseDriver(elemOrDriver) ? elemOrDriver.elem : elemOrDriver;
    var isChildVisible = function (selector) { return !!elem.querySelector(selector); };
    var baseDriver = {
        getText: function () { return elem.textContent || ''; },
        elem: elem,
        find: function (selector) {
            var child = answers_lib_1.ensureExists(elem.querySelector(selector), "Element with selector " + selector + " does not exist");
            return exports.getBaseReactDriver(child);
        },
        getAttribute: function (name) { return elem.getAttribute(name) || ''; },
        findAll: function (selector) {
            var bds = Array.prototype.slice.call(elem.querySelectorAll(selector)).map(exports.getBaseReactDriver);
            return exports.createBaseDriverList(bds);
        },
        isChildVisible: isChildVisible,
        waitUntilVisible: function (selector) {
            return answers_lib_1.eventually(function () { return isChildVisible(selector); });
        },
        click: function () {
            exports.simulateClick(elem);
        },
        enterValue: function (value) {
            exports.enterValue(elem, value);
        },
        pressKey: function (keyCode) {
            exports.pressKey(elem, keyCode);
        },
        getDataAttr: function (name) { return elem.getAttribute("data-" + name) || ''; },
        getInnerHtml: function () { return elem.innerHTML; },
        hasClass: function (name) { return elem.classList.contains(name); },
        mouseOver: function () {
            exports.simulateMouseOver(elem);
        },
        mouseOut: function () {
            exports.simulateMouseOut(elem);
        },
        mouseEnter: function () {
            test_utils_1.Simulate.mouseEnter(elem);
        },
        mouseDown: function () {
            test_utils_1.Simulate.mouseDown(elem);
        }
    };
    return baseDriver;
};
exports.getLegacyBaseDriverFromWrapper = function (wrapper, selector, name) {
    var namespacedSelector = "." + namespace_classes_1.namespaceClassName + selector;
    var elements = wrapper.querySelectorAll(namespacedSelector);
    if (elements.length === 0) {
        throw new Error("Unable to locate " + name + " component for given wrapper");
    }
    if (elements.length > 1) {
        throw new Error("There is more than one [" + name + "] for given wrapper. Please be more specific");
    }
    return exports.getBaseReactDriver(elements[0]);
};
//# sourceMappingURL=base-driver.js.map